import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, Sidebar as SidebarPro, SubMenu } from 'react-pro-sidebar';
import { Typography, Box } from '@mui/material';
import styles from './index.module.css';
import { isSelectedFilterNotEmpty } from '../../helpers/filters';
import "./sidebar.scss";

const FILTER_IMAGE = 'https://members.performancegolf.com/wp-content/uploads/2025/12/filter-icon-gray.svg';
const CLOSE_IMAGE = 'https://members.performancegolf.com/wp-content/uploads/2025/12/clear-button.svg';
const DROP_DOWN_ARROW = 'https://members.performancegolf.com/wp-content/uploads/2025/04/dropDownFilterArrow.svg'
interface Filter {
    title: string;
    value: number;
    category: string;
}

interface FilterData {
    filterType: string;
    data: Filter[];
}

function formatGolfString(input: string): string {
    let formatted = input;

    const chippingBunkersRegex = /\bChipping\s+Bunkers\b/g;
    formatted = formatted.replace(chippingBunkersRegex, 'Chipping & Bunkers');

    const chippingAndBunkersColonRegex = /\bChipping\s*&\s*Bunkers\b(?!:)/;
    formatted = formatted.replace(chippingAndBunkersColonRegex, (match, offset, string) => {
        const afterMatch = string.slice(offset + match.length).trim();
        if (afterMatch.length > 0 && !afterMatch.startsWith(':')) {
            return `${match}: `;
        }
        return match;
    });

    const otherTerms = ['Putting', 'Mental Game', 'Wedge Game', 'Driving', 'Ball Striking'];

    otherTerms.forEach(term => {
        const termRegex = new RegExp(`\\b${term}\\b(?!:)(?=\\s+\\S)`, 'g');
        formatted = formatted.replace(termRegex, `${term}: `);
    });

    return formatted;
}
interface Props {
    filterData: FilterData[];
    isSidebarOpen: boolean;
    handleSidebarToggle: () => void;
    selectedFilters: Record<string, string[]>;
    onFilterTypeChange: (filterType: string, isChecked: boolean) => void;
    onFilterChange: (filterType: string, category: string, isChecked: boolean) => void;
    handleResetFilter: () => void;
    isSC?:boolean
}
function Sidebar({ handleSidebarToggle, isSidebarOpen, filterData, onFilterChange, onFilterTypeChange, selectedFilters, handleResetFilter, isSC }: Props) {
    const [openStates, setOpenStates] = useState<Record<string, boolean>>({});

    // Initialize open states when component mounts or filterData changes
    useEffect(() => {
        const initialStates = filterData.reduce((acc, filter) => {
            acc[filter.filterType] = true;
            return acc;
        }, {} as Record<string, boolean>);
        setOpenStates(initialStates);
    }, [filterData]);

    const handleCollapseAll = () => {
        const anyOpen = Object.values(openStates).some(state => state);
        const newState = !anyOpen;
        
        const newStates = filterData.reduce((acc, filter) => {
            acc[filter.filterType] = newState;
            return acc;
        }, {} as Record<string, boolean>);
        setOpenStates(newStates);
    };

    const handleSubmenuToggle = (filterType: string, isOpen: boolean) => {
        setOpenStates(prev => ({
            ...prev,
            [filterType]: isOpen
        }));
    };

    // Check if any submenu is open
    const anySubmenuOpen = Object.values(openStates).some(state => state);

    console.log("TEST 16");

    return (
        <>
        {isSidebarOpen ?(
            <SidebarPro
                className={styles.sidebarContainer}
                width={isSidebarOpen ? '331px' : '0'}
                backgroundColor='#FFF'
                style={{
                    border: !isSidebarOpen ? 'none' : '1px',
                    marginLeft: isSidebarOpen ? '16px' : '0px',
                    marginTop: isSidebarOpen ? '18px' : '0px',
                }}
            >
                <Menu 
                    menuItemStyles={{
                        button: {
                            "&:hover": {
                                backgroundColor: "transparent !important",
                            },
                        },
                        subMenuContent: {
                            backgroundColor: "transparent",
                            transition: "none",
                        },
                    }}
                    transitionDuration={0}
                    closeOnClick={false}
                >
                    <div className="menuItemHover" style={{ paddingLeft: '13px' }}>
                        <div className="filterBox" >
                            <div className="filterBoxContainer">
                                <img src={FILTER_IMAGE} alt='' />
                                <p className="filterBoxContainerLabel" style={{fontFamily: "'Repro', sans-serif"}}>Filter</p>
                            </div>
                            <div onClick={handleResetFilter} className={isSelectedFilterNotEmpty(selectedFilters) ? "clearAllActive learAllTextContainer"  : "nonActive learAllTextContainer"}>
                                <p className={isSelectedFilterNotEmpty(selectedFilters) ? "clearAllTextActive filterClearAllLabel" : "clearAllTextNonActive filterClearAllLabel"}>Clear All</p>
                            </div>
                        </div>
                        <div className="imgContainer">
                            <img onClick={handleSidebarToggle} src={CLOSE_IMAGE} />
                        </div>
                    </div>
                    {/*<div className="collapseContainer" onClick={handleCollapseAll}>
                        <p>{anySubmenuOpen ? 'Collapse All' : 'Expand All'}</p>
                    </div>*/}
                    {filterData.map((filter) => (
                        <SubMenu
                            suffix={<img src={DROP_DOWN_ARROW} alt='' />}
                            key={filter.filterType}
                            className={styles.subMenuClass}
                            defaultOpen={true}
                            open={openStates[filter.filterType]}
                            onOpenChange={(isOpen) => handleSubmenuToggle(filter.filterType, isOpen)}
                            label={
                                <React.Fragment>
                                    <Box className={styles.subMenuWrapper}>
                                        <input
                                            onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
                                            type="checkbox"
                                            id={`${filter.filterType}Checkbox`}
                                            checked={!selectedFilters[filter.filterType]?.length || false}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFilterTypeChange(filter.filterType, e.target.checked)}
                                            style={{ width: '12px', height: '12px' }}
                                        />
                                        <Typography fontSize={22} fontWeight={500} style={{ marginLeft: 13, textTransform: 'uppercase', fontFamily: "'Repro', sans-serif" }}>
                                            {filter.filterType}{isSC ? "s" : ""} ({filter.data.length})
                                        </Typography>
                                    </Box>
                                </React.Fragment>
                            }
                            style={{ paddingLeft: '13px', height: '46px', borderBottom: '1px solid #DCDCDC' }}>
                            <Box mt={3.6} mb={3.6}>
                                {filter.data.map((el) => {
                                    const isChecked = selectedFilters[filter.filterType]?.includes(el.category) || false;
                                    return (<MenuItem key={el.category} className={styles.subItem} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: '100%',
                                        paddingLeft: '13px',
                                        height: 'auto',
                                        marginBottom: '5px'
                                    }}>
                                        <Box className={styles.subItemWrapper} sx={{
                                            display:isSC ? 'flex' : 'unset',
                                            alignItems:isSC ? 'center' : 'unset'
                                        }}>
                                            <input
                                                type="checkbox"
                                                id={`${el.category}Checkbox`}
                                                checked={isChecked}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFilterChange(filter.filterType, el.category, e.target.checked)}
                                                style={{ width: '12px', height: '12px' }}
                                            />
                                            <label 
                                                htmlFor={`${el.category}Checkbox`} 
                                                className={styles.labelItemTitle} 
                                                style={{
                                                    marginLeft: '13px',
                                                    color: '#7B726C',
                                                    flex: '1',
                                                    whiteSpace: 'nowrap',
                                                    textWrap: isSC ? 'wrap' : 'nowrap'
                                                }}
                                            >
                                                {isSC ? formatGolfString(el.title) : el.title}
                                            </label>
                                            <label className={styles.labelValue} style={{ marginLeft: '5px' }}>
                                                {!isSC && `(${el.value})`}
                                            </label>
                                        </Box>
                                    </MenuItem>)
                                })}
                            </Box>
                        </SubMenu>
                    ))}
                </Menu>
            </SidebarPro>
        ) : null}
        </>
    );
}

export default Sidebar;
